import React, { useEffect, useContext, useState } from 'react'
import cn from 'classnames'
import { CustomerContext } from '../../../contexts/CustomerContext'
import StudentImage from '../../../models/StudentImage'
import Typography from '../../Typography'
import Grid from '../../Grid'
import Button from '../../Button'
import styles from './PreviousImages.module.sass'
import { OrderPackage, Package } from '../../../models/_models'
import { Link, useHistory, useLocation } from "react-router-dom"
import Spinner from '../../Spinner'
import PreviewImage from '../../PreviewImage/PreviewImage'
import routes from '../../../routes';
import useLocalStorage from "../../../hooks/useLocalStorage";

const PreviousImages = () => {
  const { customer, setCustomer } = useContext(CustomerContext)
  const history = useHistory()
  const location = useLocation()
  const [studentImages, setStudentImages] = useState([])
  const [packages, setPackages] = useState([])
  const [loading, setLoading] = useState(true)
  const [hasNoPastImages, setHasNoPastImages] = useState(false)
  const [isUsingAccessCode] = useLocalStorage('isUsingAccessCode')

  const isPastImages = location.pathname.includes('past_images')
  const isDownloadImages = location.pathname.includes('download-image')

  useEffect(() => {
    const cartKey = customer.priorityCart ? 'priorityCart' : 'cart'
    const query = isDownloadImages ? { studentId: customer.currentStudent.id } : { folder: { not_already_selected_for_cart: customer[cartKey].id } };

    if (!isUsingAccessCode && !isDownloadImages) {
      history.push('/review')
      return
    }

    StudentImage
      .includes('poses')
      .selectExtra(['packageId'])
      .where({ studentId: customer.currentStudent.id })
      .where(query)
      .all()
      .then(response => {
        if (response.data.length === 0) {
          if (!isDownloadImages) {
            history.push('/review')
          }
          else {
            setLoading(false)
            setHasNoPastImages(true)
          }
          return
        }

        Package
          .includes({ backgroundSet: ['backgrounds', 'defaultBackground'] })
          .where({ forPastImages: true })
          .where({ id: response.data.map(datum => datum.packageId )})
          .all()
          .then(packageRes => {
            const tempImages = response.data.filter(image => image.watermarkUrl && !image.watermarkUrl.includes('missing.png') && !!image.packageId)

            setPackages(packageRes.data)
            if (tempImages.length === 0 && !isDownloadImages) history.push('/review')
            setStudentImages(tempImages)
            if (tempImages.length === 0) {
              setHasNoPastImages(true)
              setTimeout(() => {
                const container = document.querySelector('#previousImagesContainer')
                if (container) {
                  container.style.display = 'none'
                }
              }, 0)
            }
            setLoading(false)
          })
      })
  }, [])

  const handleNav = studentImage => {
    const cartKey = customer.priorityCart ? 'priorityCart' : 'cart'

    const newOrderPackage = new OrderPackage({
      cartId: customer[cartKey].id,
      studentId: customer.currentStudent.id,
      studentImageId: studentImage.id,
      studentImage: studentImage,
      isPreviewHidden: false,
    })

    localStorage.setItem(`currentSeason-${customer.currentStudent.id}`, studentImage.folder);

    setCustomer({ ...customer, currentOrderPackage: newOrderPackage })

    const selectedPackage = packages.find(pack => pack.id === studentImage.packageId.toString())
    const hasBackgrounds = selectedPackage.backgroundSet && selectedPackage.backgroundSet.backgrounds.length > 0

    if (selectedPackage.multiple && studentImage.poses && studentImage.poses.length > 0) history.push(routes.elementaryMultiPoseBuilder(selectedPackage.id, { pastImages: true }))
    else if (studentImage.isPNG() && hasBackgrounds) history.push(`/background_selection/${selectedPackage.id}`)
    else history.push(`/option_selection/${selectedPackage.id}`)
  }

  const backgroundUrl = (studentImage) => {
    const currentPackage = packages.find(pack => pack.id === studentImage.packageId.toString())

    if (!currentPackage) return '';

    if (currentPackage.backgroundSet && currentPackage.backgroundSet.backgrounds.length > 0 && studentImage.isPNG()) {
      return currentPackage.backgroundSet.defaultBackground.imageUrl
    }

    return '';
  }

  if (loading) return <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}><Spinner color='blue' /></div>
  if (hasNoPastImages) return null

  return (
    <>
      <div className={styles.outerContainer}>
        <Grid container classes={cn(styles.previousImagesContainer, styles.maxWidth)} xs={10} md={8} direction='column'>
          <Grid item>
            {!isDownloadImages ? (
              <>
                <Typography align="center" weight="bold" classes={cn(styles.blue, styles.thankYou)}>Thank you</Typography>
                <Typography align="center" weight="bold" classes={cn(styles.blue, styles.question)}>Would you like to add any of the images below to your order?</Typography>
                <Typography align="center" weight="bold">Click to select or Proceed to Checkout</Typography>
              </>
            ) : (
              <>
                <Typography align="center" weight="bold" classes={cn(styles.blue, styles.question)}>Purchase pictures and images from previous school years!</Typography>
                <Typography align="center" weight="bold" classes={styles.question}>Click an image below to begin purchasing.</Typography>
              </>
            )}
          </Grid>
          <Grid container item classes={styles.imgContainer}>
            {studentImages.map((studentImage, _i) => {
              if (!packages.find(pack => pack.id === studentImage.packageId.toString())) return null;

              return (
                <Grid item xs={4} key={studentImage.id}>
                  <div className={styles.imageWrapper} onClick={() => handleNav(studentImage)}>
                    <PreviewImage
                      foregroundUrl={studentImage.watermarkUrl}
                      backgroundUrl={backgroundUrl(studentImage)}
                    />
                    {isPastImages && <Button fullWidth variant='primary' classes={styles.button}
                                             onClick={() => handleNav(studentImage)}>Purchase</Button>}
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </div>
      {!isDownloadImages && (
        <Grid container justify='center' classes={cn(styles.maxWidth, styles.bottomContainer)} spacing={2}>
          <Grid item xs={10} md={8}>
            {isPastImages ? (
              <Button fullWidth variant='submit' onClick={() => history.goBack()}>Return to Previous Page</Button>
            ) : (
              <Link to='/review'>
                <Button fullWidth variant='submit'>
                  Proceed to Check Out
                </Button>
              </Link>
            )}
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default PreviousImages
